module.exports = __webpack_public_path__ + "static/media/remove.549992d5.svg";